import { VirtualizedList } from 'react-native';
import { styled } from '../../styled';
export default styled(VirtualizedList, {
    w: '$full',
    h: 'auto',
}, {
    componentName: 'ActionsheetVirtualizedList',
});
